import { z } from 'zod';
import { paginatedQuerySchema } from '~/util/types/api';

export const clansParamsSchema = z
    .object({
        name_filter: z.string().nullable().default(null),
    })
    .extend(paginatedQuerySchema().shape);

export type clansParamsType = z.input<typeof clansParamsSchema>;
export const defaultClansParams = clansParamsSchema.parse({});
